/** Static content for teacher landing id=3 (Key2English / Наталія Кий). */
const asset = (name) => `/landing/teacher-3/${name}`;

const teacher3 = {
  id: '3',
  brand: 'Key2English',
  teacherName: 'Наталія Кий',
  locale: 'uk',
  links: {
    telegram: 'https://t.me/+YH50mwzNh0tiNWYy',
    instagram: 'https://instagram.com/nataly.kii.english',
    instagramHandle: '@nataly.kii.english',
  },
  images: {
    heroClassroom: asset('hero-classroom.png'),
    teacherPortraitHome: asset('teacher-portrait-home.png'),
    teacherPortraitAbout: asset('teacher-portrait-about.png'),
    storyDiploma: asset('story-diploma.png'),
  },
  nav: [
    { id: 'home', label: 'Головна', path: '' },
    { id: 'about', label: 'Про мене', path: 'about' },
    { id: 'courses', label: 'Курси', path: 'courses' },
    { id: 'contact', label: 'Контакти', action: 'contact' },
    // { id: 'offer', label: 'Оферта', path: 'offer' },
  ],
  ctaLabel: 'Записатись',
  contact: {
    title: "Зв'яжіться зі мною",
    subtitle:
      'Запишіться на безкоштовний діагностичний урок або поставте будь-яке запитання — відповім протягом дня.',
    socialHeading: "Як зі мною зв'язатись",
    telegramLabel: 'Написати в Telegram',
    telegramHint: "Найшвидший спосіб зв'язатись",
    instagramHint: 'Слідкуйте за порадами та новинами',
    responseNote: 'Відповідаю протягом дня в будні.',
    formTitle: 'Записатись на безкоштовний урок',
    formSubtitle:
      "Заповніть форму — я зв'яжусь з вами протягом 24 годин, щоб узгодити зручний час.",
    fieldsVisible: false,
    fields: {
      name: { label: "Ваше ім'я", placeholder: 'Наприклад: Олена' },
      email: { label: 'Email', placeholder: 'your@email.com' },
      goal: {
        label: 'Ваша мета',
        placeholder: 'Оберіть мету',
        options: [
          'Підготовка до IELTS',
          'Підготовка до CAE',
          'Підготовка до CPE',
          'General English',
          'Інше',
        ],
      },
      message: {
        label: 'Розкажіть про себе',
        placeholder:
          'Ваш поточний рівень, коли плануєте іспит, будь-які запитання...',
      },
      submit: 'Надіслати заявку',
    },
  },
  home: {
    badge: 'ОНЛАЙН-ПІДГОТОВКА ДО МІЖНАРОДНИХ ІСПИТІВ',
    headline: 'Твій ключ до CAE & IELTS',
    subhead:
      'Персональний підхід, перевірена методика та реальні результати — від Band 7.0 до Grade A.',
    primaryCta: 'Записатись на урок',
    secondaryCta: 'Дізнатись більше',
    successLabel: 'Успішність студентів',
    successValue: '94%',
    offerEyebrow: 'ЩО Я ПРОПОНУЮ',
    offerTitle: 'Курси, що дають результат',
    courseCards: [
      {
        headerImage: asset('courses-header-popular.png'),
        badge: 'Найпопулярніший',
        title: 'Підготовка до CAE',
        subtitle: 'Cambridge C1 Advanced',
        body: 'Системна підготовка до всіх компонентів іспиту: Reading, Writing, Listening, Speaking та Use of English. Від B2 до впевненого Grade A.',
        meta: ['3–6 місяців', 'Індивідуально онлайн'],
      },
      {
        headerImage: asset('courses-header-learning.png'),
        badge: 'Для міграції та навчання',
        title: 'Підготовка до IELTS',
        subtitle: 'Academic & General Training',
        body: 'Цільова підготовка до Academic або General IELTS. Стратегії для кожного модуля, розбір типових помилок та практика з реальними матеріалами.',
        meta: ['2–5 місяців', 'Індивідуально онлайн'],
      },
      {
        headerImage: asset('courses-header-business.png'),
        badge: 'Для бізнесу та повсякдення',
        title: 'General English',
        subtitle: 'Від A2 до C1',
        body: 'Розмовна англійська, граматика та словниковий запас для впевненого спілкування в роботі та житті. Гнучкий графік, живі теми.',
        meta: ['Від 1 місяця', 'Індивідуально онлайн'],
      },
    ],
    aboutEyebrow: 'ПРО ВИКЛАДАЧА',
    aboutTitle: 'Досвід, що підтверджений результатами',
    aboutBody:
      'Я — сертифікований викладач англійської з 8+ роками досвіду підготовки до CAE та IELTS. Мої студенти отримують цільові бали та вступають до університетів Великобританії, Канади та Австралії.',
    aboutStats: [
      { value: '8+', label: 'років досвіду' },
      { value: '20+', label: 'студентів склали іспит' },
      { value: '94%', label: 'досягають цільового балу' },
    ],
    aboutCta: 'Більше про мене',
    certs: ['CELTA certified', 'Cambridge Examiner', 'IELTS Band 9.0'],
    resultsEyebrow: 'РЕЗУЛЬТАТИ СТУДЕНТІВ',
    resultsTitle: 'Цифри, що говорять самі за себе',
    testimonials: [
      {
        score: '7.5',
        exam: 'IELTS',
        quote:
          'Завдяки чіткій методиці та постійному фідбеку я підвищила бал з 5.5 до 7.5 та навчаюсь на магістратурі в університеті мрії — Erasmus University',
        name: 'Софія Н.',
        detail: 'Університет у Нідерландах',
      },
      {
        score: 'B',
        exam: 'CAE Grade',
        quote:
          'Найкращий викладач для підготовки до CAE. Структурований підхід та реальні матеріали — саме те, що потрібно.',
        name: 'Дарія, 15 років',
        detail: 'Школярка з Києва',
      },
      {
        score: '7.5',
        exam: 'IELTS',
        quote:
          'Спочатку підготувалась з Наталією до CAE і вступила до університету в Парижі, а згодом звернулась за IELTS 7.5 для програми обміну. За 2 місяці ми опрацювали формат, і я отримала бажаний результат. Зараз навчаюсь в Essex Uni',
        name: 'Варвара.',
        detail: 'Essex University',
      },
    ],
    readyTitle: 'Готовий розпочати?',
    readyBody: 'Перший урок — безкоштовна діагностика вашого рівня та цілей.',
    readyCta: 'Записатись на безкоштовний урок',
    readyNote: "Без зобов'язань. Просто поговоримо про ваші цілі.",
  },
  about: {
    heroBadge: 'ПРО МЕНЕ',
    heroTitle:
      'Я допомагаю студентам досягати цілей і вчити мову з задоволенням',
    profileCardEyebrow: 'ВАШ ПАРТНЕР У ПІДГОТОВЦІ ДО IELTS',
    profileCardBio:
      'Більше 10 років допомагаю студентам впевнено почуватися на IELTS та реалізовувати свої академічні та кар\'єрні амбіції за кордоном',
    partnerEyebrow: 'ВАШ ПАРТНЕР У ПІДГОТОВЦІ ДО IELTS, CAE ТА CPE',
    intro:
      'Більше 10 років я допомагаю студентам впевнено скласти IELTS, CAE та CPE і реалізувати свої академічні та кар\'єрні амбіції за кордоном. Мої студенти вступають до магістратури в університети Європи та США — з першого разу.',
    stats: [
      { value: '8+', label: 'років досвіду' },
      { value: '20+', label: 'студентів склали іспит' },
      { value: '94%', label: 'досягають цільового балу' },
      { value: '7.0', label: 'середній бал IELTS студентів' },
    ],
    storyEyebrow: 'МОЯ ІСТОРІЯ',
    storyTitle: 'Результати студентів — моя головна мотивація',
    storyQuote: 'Знати мову і вміти скласти іспит — це різні навички.',
    storyBody: [
      'Я викладаю англійську понад 18 років і останні 10 спеціалізуюся на підготовці до міжнародних іспитів: IELTS, CAE та CPE. Я співпрацюю з колишніми екзаменаторами і ми разом розробили методику, яка допомагає студентам не просто вивчити мову, а впевнено показати свій рівень на іспиті.',
      'Мої студенти складають IELTS на 7.0 і вище, отримують CAE та CPE з першого разу і вступають до бакалаврату та магістратури в університети Великої Британії, Нідерландів, Австрії та США. Це і є мій головний результат.',
      'Я працюю виключно онлайн з індивідуальними студентами. Ніяких великих груп, ніяких шаблонних програм — тільки персональний підхід і чіткий фокус на вашій меті.',
    ],
    qualEyebrow: 'КВАЛІФІКАЦІЯ',
    qualTitle: 'Підтверджена експертиза',
    qualifications: [
      {
        year: '2026',
        title: 'LTC',
        body: 'Language Transformational Coaching - ICF Certified',
        tone: 'brown',
      },
      {
        year: '2014',
        title: 'TKT Band 4',
        body: 'Teaching Knowledge Test, Band 4 — найвищий можливий результат. Підтверджує глибоке розуміння методики викладання англійської мови — Cambridge University Press & Assessment',
        tone: 'beige',
      },
      {
        year: '2011',
        title: 'MA in English Philology',
        body: 'Магістр прикладної лінгвістики — Київський національний університет',
        tone: 'peach',
      },
      {
        year: '2015',
        title: 'CPE — Certificate of Proficiency in English',
        body: 'Найвищий рівень Cambridge English (C2). Підтверджує повне володіння англійською мовою на рівні освіченого носія — визнається університетами та роботодавцями по всьому світу',
        tone: 'rose',
      },
    ],
    methodEyebrow: 'МЕТОДИКА',
    methodTitle: 'Як я працюю',
    steps: [
      {
        n: '01',
        title: 'Діагностика',
        body: 'Перший урок - діагностика. Я оцінюю ваш поточний рівень, розумію цілі та визначаю слабкі місця, які потрібно опрацювати.',
      },
      {
        n: '02',
        title: 'Персональний план',
        body: 'На основі діагностики я складаю індивідуальну програму підготовки з чіткими тижневими цілями та реалістичними дедлайнами.',
      },
      {
        n: '03',
        title: 'Практика з фідбеком',
        body: 'Кожен урок — це практика реальних завдань іспиту з детальним розбором помилок. Я пояснюю не тільки «що», але й «чому».',
      },
      {
        n: '04',
        title: 'Результат',
        body: 'Регулярні mock tests показують прогрес. Ви йдете на іспит підготовленим, впевненим і з чіткою стратегією для кожного модуля.',
      },
    ],
    bandTitle: 'Хочете дізнатись, чи підходить мій підхід саме вам?',
    bandBody: "Запишіться на безкоштовний діагностичний урок — без зобов'язань.",
    bandCta: 'Записатись на безкоштовний урок',
  },
  courses: {
    badge: 'КУРСИ ТА ЦІНИ',
    title: 'Оберіть свій шлях до результату',
    subhead:
      'Індивідуальні онлайн-заняття з підготовки до IELTS, CAE та CPE. Без груп — тільки ви і чіткий план до вашого балу.',
    primaryCta: 'Безкоштовна діагностика',
    items: [
      {
        badge: 'Найпопулярніший',
        title: 'Підготовка до IELTS',
        subtitle: 'Academic & General Training',
        body: 'Повна підготовка до всіх чотирьох модулів IELTS: Reading, Writing, Listening та Speaking. Фокус на стратегіях виконання завдань, типових пастках та тайм-менеджменті. Цільовий бал — від 7.0 і вище.',
        tags: ['Онлайн, 1-на-1', '60 хвилин / урок', 'B2–C1'],
        bullets: [
          'Усі 4 модулі: Reading, Writing, Listening, Speaking',
          'Регулярні mock tests з детальним розбором',
          'Стратегії для кожного типу завдань',
          'Персональний план підготовки',
          'Домашні завдання з фідбеком між уроками',
        ],
      },
      {
        badge: 'C1 Advanced',
        title: 'Підготовка до CAE',
        subtitle: 'Cambridge C1 Advanced',
        body: 'Підготовка до Cambridge C1 Advanced (CAE) — іспиту, який визнається тисячами університетів та роботодавців по всьому світу. Охоплює всі п\'ять компонентів: Reading & Use of English, Writing, Listening, Speaking.',
        tags: ['Онлайн, 1-на-1', '60 хвилин / урок', 'B2+'],
        bullets: [
          'Усі 5 компонентів CAE',
          'Розбір форматів завдань Use of English',
          'Writing: essays, reports, proposals, reviews',
          'Speaking: long turn, collaborative task, discussion',
          'Практика з автентичними матеріалами Cambridge',
        ],
      },
      {
        badge: 'C2 Proficiency',
        title: 'Підготовка до CPE',
        subtitle: 'Cambridge C2 Proficiency',
        body: 'CPE (Certificate of Proficiency in English) — найвищий рівень Cambridge English (C2). Підтверджує повне володіння мовою на рівні освіченого носія, визнається університетами Великої Британії, США, Австралії та Канади без додаткових мовних вимог.',
        tags: ['Онлайн, 1-на-1', '60 хвилин / урок', 'C1+'],
        bullets: [
          'Найвищий рівень Cambridge English — C2',
          'Reading & Use of English: складні лексичні трансформації',
          'Writing: essays, articles, reviews на академічному рівні',
          'Speaking: abstract discussion, negotiation',
          'Визначається університетами без терміну дії',
        ],
      },
    ],
    priceLabel: 'ВАРТІСТЬ',
    priceValue: 'Уточнюється індивідуально',
    priceHint: 'Залежить від поточного рівня та цільового балу',
    offerTitle: 'Перший урок (20 хв) — безкоштовно',
    offerBody: 'Діагностика рівня, обговорення цілей і персональний план підготовки.',
    bookCta: 'Записатись на діагностику',
    howEyebrow: 'ЯК ЦЕ ПРАЦЮЄ',
    howTitle: 'Від першого уроку до результату',
    howSteps: [
      {
        n: '1',
        title: 'Безкоштовна діагностика',
        body: 'Перший урок — безкоштовно. Я оцінюю ваш рівень, розумію цілі та визначаю, скільки часу потрібно на підготовку.',
      },
      {
        n: '2',
        title: 'Персональний план',
        body: 'Після діагностики ви отримуєте чіткий план підготовки з тижневими цілями та рекомендованою кількістю уроків.',
      },
      {
        n: '3',
        title: 'Регулярні заняття',
        body: 'Заняття 1-2 рази на тиждень онлайн. Між уроками — домашні завдання з письмовим фідбеком.',
      },
      {
        n: '4',
        title: 'Іспит і результат',
        body: 'Ви йдете на іспит підготовленим і впевненим. Більшість моїх студентів досягають цільового балу з першої спроби.',
      },
    ],
    faqEyebrow: 'ЧАСТІ ЗАПИТАННЯ',
    faqTitle: 'Відповіді на головні питання',
    faq: [
      {
        q: 'Скільки уроків потрібно для підготовки?',
        a: 'Залежить від вашого поточного рівня та цільового балу. В середньому — від 2 до 6 місяців занять 1-2 рази на тиждень. Точну оцінку я даю після безкоштовної діагностики.',
      },
      {
        q: 'Чи можна займатись, якщо рівень нижче B2?',
        a: 'Для підготовки до IELTS, CAE або CPE рекомендований стартовий рівень — B2. Якщо ваш рівень нижче, я можу порекомендувати, як його підтягнути перед початком підготовки до іспиту.',
      },
      {
        q: 'Як проходять заняття?',
        a: 'Усі заняття — онлайн через Zoom або Google Meet. Вам потрібен лише комп’ютер з мікрофоном та стабільний інтернет. Матеріали я надсилаю заздалегідь.',
      },
      {
        q: 'Чи є домашні завдання?',
        a: 'Так. Між уроками я даю письмові завдання (есе, листи, звіти) та отримуєте детальний письмовий фідбек. Це критично важливо для Writing та Speaking.',
      },
      {
        q: 'Як записатись?',
        a: 'Напишіть мені через форму нижче або в Telegram. Ми домовимось про зручний час для безкоштовного діагностичного уроку.',
      },
    ],
    bandTitle: 'Готові почати?',
    bandBody: 'Перший урок - безкоштовна діагностика. Без зобов\'язань.',
    bandCta: 'Записатись',
  },
  footer: {
    tagline:
      'Онлайн-підготовка до CAE та IELTS. Результати, які говорять самі за себе.',
    navHeading: 'НАВІГАЦІЯ',
    contactsHeading: 'КОНТАКТИ',
    legalHeading: 'ПРАВОВА ІНФОРМАЦІЯ',
    copyright: '© 2026 Key2English. Всі права захищені.',
  },
  /**
   * WayForPay site requirements stub
   * (https://help.wayforpay.com/view/13729832).
   * Replace all [ЗАПОВНИТИ …] placeholders before payment go-live.
   * Structure mirrors common UA online-education offers (remote service,
   * no physical delivery, explicit no-refund policy).
   */
  legal: {
    path: 'offer',
    footerLabel: 'Публічна оферта',
    badge: 'ПРАВОВА ІНФОРМАЦІЯ',
    title: 'Публічна оферта та умови надання послуг',
    intro:
      'Ця сторінка містить контактні реквізити продавця, умови надання дистанційних освітніх послуг, способи оплати, політику повернення коштів та текст публічного договору (оферти) відповідно до вимог платіжного сервісу.',
    updatedLabel: 'Редакція від',
    updatedAt: '[ЗАПОВНИТИ: дата редакції, напр. 25.10.2026]',
    stubNotice:
      'Увага: реквізити продавця та юридичні формулювання нижче — заглушки. Замініть їх актуальними даними перед підключенням оплати.',
    tocLabel: 'Зміст',
    provider: {
      heading: 'Контактна інформація продавця',
      legalNameLabel: 'Повне фірмове найменування',
      legalName: '[ЗАПОВНИТИ: ФОП ПІБ або повна назва юридичної особи]',
      taxIdLabel: 'ІПН / ЄДРПОУ',
      taxId: '[ЗАПОВНИТИ: ІПН або ЄДРПОУ]',
      legalAddressLabel: 'Юридична адреса',
      legalAddress: '[ЗАПОВНИТИ: юридична адреса]',
      actualAddressLabel: 'Фактична адреса',
      actualAddress: '[ЗАПОВНИТИ: фактична адреса / адреса для листування]',
      phoneLabel: 'Телефон',
      phone: '[ЗАПОВНИТИ: телефон у міжнародному форматі]',
      emailLabel: 'Email',
      email: '[ЗАПОВНИТИ: email організації / ФОП]',
    },
    sections: [
      {
        id: 'terms',
        title: '1. Правила та умови надання послуг',
        paragraphs: [
          'Виконавець надає Замовнику платні освітні (інформаційно-консультаційні) послуги з підготовки до міжнародних іспитів з англійської мови (зокрема IELTS, CAE, CPE) та/або загальної англійської мови у форматі індивідуальних онлайн-занять.',
          'Послуги надаються виключно дистанційно за допомогою засобів відеозв’язку (наприклад, Zoom або Google Meet) та електронного обміну навчальними матеріалами. Фізична передача товарів, кур’єрська чи поштова доставка не здійснюються.',
          'Територія надання послуг — онлайн, без прив’язки до конкретного міста чи країни проживання Замовника. До правовідносин сторін застосовується законодавство України.',
          'Строк і обсяг послуг (кількість уроків, тривалість уроку, період доступу до матеріалів) узгоджуються індивідуально та/або зазначаються на сторінках Сайту чи в повідомленні після діагностики. Послуга вважається наданою в частині проведеного заняття з моменту його проведення у погоджений час (у тому числі якщо Замовник не з’явився без завчасного перенесення за правилами Виконавця).',
          'Актуальний опис курсів і орієнтовні умови розміщені на сторінці «Курси» Сайту. Остаточна вартість і план підготовки можуть уточнюватися після безкоштовної діагностики.',
        ],
        list: [
          'Формат: індивідуальні онлайн-заняття 1-на-1',
          'Початок надання послуг: після оплати та узгодження розкладу',
          'Технічні умови на боці Замовника: пристрій, мікрофон/камера, стабільний інтернет',
        ],
      },
      {
        id: 'payment',
        title: '2. Вартість і способи оплати',
        paragraphs: [
          'Вартість послуг визначається Виконавцем і повідомляється Замовнику до оплати (на Сайті та/або в особистому листуванні). Якщо інше не погоджено письмово, оплата здійснюється у вигляді 100% передоплати обраного пакета або уроку.',
          'Оплата здійснюється безготівково через платіжний сервіс WayForPay банківськими картками Visa / MasterCard та іншими способами, які доступні в платіжній формі WayForPay на момент оплати.',
          'Послуга вважається оплаченою з моменту успішного зарахування коштів на рахунок Виконавця. Комісії банків і платіжних систем, якщо вони стягуються з платника, Замовник сплачує самостійно, якщо інше не зазначено в платіжній формі.',
          'Валюта розрахунків — гривня (UAH), якщо інше прямо не передбачено платіжною формою.',
        ],
        list: [
          'Платіжні картки Visa / MasterCard',
          'Оплата через WayForPay',
          'Інші методи, доступні в інтерфейсі WayForPay (за наявності)',
        ],
      },
      {
        id: 'refund',
        title: '3. Правила повернення коштів (Refund policy)',
        paragraphs: [
          'Повернення грошових коштів, відшкодування та скасування успішної транзакції після оплати послуг не передбачені.',
          'Оскільки послуги є дистанційними освітніми послугами індивідуального характеру, а доступ до узгодженого формату занять і/або матеріалів надається після оплати, Замовник підтверджує, що ознайомлений із відсутністю процедури повернення коштів і погоджується з цим до здійснення оплати.',
          'У разі технічної помилки платіжної системи (подвійне списання тощо) Замовник звертається до Виконавця за контактами з цього розділу; розгляд таких звернень здійснюється в індивідуальному порядку та не змінює загального правила про відсутність повернення за надані чи заброньовані послуги.',
          '[ЗАПОВНИТИ за потреби: винятки (наприклад, скасування Виконавцем з власної ініціативи) — або залишити лише правило «повернення не передбачено».]',
        ],
      },
      {
        id: 'offer',
        title: '4. Публічний договір (оферта)',
        paragraphs: [
          'Цей розділ є офіційною пропозицією (публічною офертою) Виконавця укласти договір про надання освітніх онлайн-послуг на викладених умовах (ст. 633, 641, 642 Цивільного кодексу України).',
          'Акцептом оферти є здійснення Замовником оплати послуг та/або інша явна дія, що свідчить про прийняття умов (зокрема підтвердження згоди в платіжній формі). З моменту акцепту договір вважається укладеним.',
          'Виконавець зобов’язується надавати послуги якісно та в узгоджені строки; Замовник зобов’язується своєчасно оплачувати послуги, надавати достовірні контактні дані та дотримуватися узгодженого розкладу.',
          'Матеріали, що передаються Замовнику в ході навчання, призначені для особистого використання. Копіювання, поширення чи комерційне використання без письмової згоди Виконавця заборонені.',
          'Виконавець має право змінювати текст оферти шляхом публікації нової редакції на цій сторінці. Для оплат, здійснених до зміни, застосовуються умови редакції, чинної на момент оплати, якщо інше не вимагається законом.',
          'Спори вирішуються шляхом переговорів; у разі недосягнення згоди — згідно із законодавством України.',
          '[ЗАПОВНИТИ: додаткові пункти (відповідальність сторін, форс-мажор, персональні дані / посилання на політику конфіденційності) за потреби юриста.]',
        ],
      },
    ],
  },
};

export default teacher3;
